export const ANALYTICS = {
  EVENTS: {
    EXPERIMENT_STARTED: '$experiment_started',
    FIRST_APP_OPEN: 'First App Open',
    ABOUT_PAGE: 'About Page',
    BLOCK_PAGE: 'Block Page',
    UNINSTALL_EXTENSION: 'Uninstall Extension',
    CUSTOMIZE_BLOCK_PAGE: 'Customize Block Page',
    PREMIUM_HOOK_CLICK: 'Premium Hook Click',
    CLOSE_BUTTON: 'Close Button',
    CLOSE_RATE_US_POPUP: 'Close Rate US Popup',
    SUBMIT_BUTTON: 'Submit Button',
    STAR_BUTTON: 'Star Button',
    MENU_BUTTON: 'Menu Button',
    MENU_POPUP: 'Menu Popup',
    SETTINGS_PAGE: 'Settings Page',
    PURCHASE_PAGE: 'Plan Picker Page',
    CHECKOUT_VIEW_VENDOR_LOGIN: 'Plan Picker Page Authentication Modal',
    PURCHASE_PAGE_CHECKOUT_VIEW: 'Plan Picker Page Checkout Modal',
    ADD_TO_BLOCK_LIST_POPUP: 'Add to Block List popup',
    AUTHENTICATION_MODAL: 'Authentication Modal',
    SUBSCRIPTION_CONFIRMATION_MODAL: 'Subscription Confirmation Modal',
    OPT_IN_POPUP: 'Opt In Popup',
    TERMS_AND_CONDITIONS_POPUP: 'T&C Popup',
    GO_TO_HOME: 'Go To Home Page Button',
    DOWNLOAD_EXTENSION: 'Download Extension Button',
    SITE_ITEM_TO_BLOCK: 'Site Item to Block',
    SITE_BLOCKING_ILLUSTRATION: 'Site Blocking Ilustration',
    DONT_BLOCK_NOW_BUTTON: 'Dont Block Now Button',
    BLOCK_AND_CONTINUE_BUTTON: 'Block And Continue Button',
    BLOCKING_ERROR_STATE: 'Blocking Error State',
    ADD_ITEMS_TO_BLOCK_LIST: 'Add Items to Block List',
    ALREADY_A_MEMBER_BUTTON: 'Already A Member Button',
    CONFIRM_PAYMENT_BUTTON: 'Confirm Payment Button',
    INVALID_PASSWORD: 'Invalid Password Message',
    FAILED_PAYMENT: 'Failed Payment',
    DONT_HAVE_AN_ACCOUNT_BUTTON: 'Dont Have An Account Button',
    DO_THIS_LATER_BUTTON: 'Do This Later Button',
    MAYBE_LATER_BUTTON: 'Maybe Later Button',
    AGREE_AND_CONTINUE_BUTTON: 'Agree And Continue Button',
    CONTINUE_BUTTON: 'Continue Button',
    TERMS_AND_CONDITIONS_POPUP_CONSENT_BUTTON: 'T&C Popup Consent Button',
    TERMS_AND_CONDITIONS_POPUP_CLOSE_BUTTON: 'T&C Popup Close Button',
    TERMS_AND_CONDITIONS_POPUP_LINK: 'T&C Popup Link',
    REVIEW_PERMISSIONS: 'Review Permissions',
    PERMISSIONS: 'Permissions',
    SKIP_FOR_LIMITED_PLAN: 'Skip For Limited Plan',
    REGISTRATION: 'Registration',
    LOGIN: 'Log In',
    LOGOUT: 'Log Out',
    PLAN_PICKER_POPUP: 'Plan Picker Popup',
    SUBSCRIPTION_BUTTON: 'Subscribe Button',
    CHECKOUT_MODAL: 'Checkout Modal',
    SUBSCRIPTION_SUCCESS: 'Subscription Success',
    OMNI_SETUP: 'Omni Setup',
    DO_IT: 'Do It',
    PIN_EXTENSION_TASK_COMPLETED: 'Pin Extension Task Completed',
    PREMIUM_CTA: 'Premium CTA',
    COMPLETED_ALL_TASKS_DIALOG: 'Completed All Tasks Dialog',
    SNOOZE: 'Snooze',
    CLAIM_DISCOUNT_BUTTON: 'Claim Discount Button',
    ADD_ITEM_BUTTON: 'Add Item Button',
    SET_SCHEDULE_BUTTON: 'Set Schedule Button',
    SET_DAILY_LIMIT_BUTTON: 'Set Daily Limit Button',
    START_FOCUS_SESSION_BUTTON: 'Start Focus Session Button',
    BACK_BUTTON: 'Back Button',
    SEE_WEEKLY_RECAP_BUTTON: 'See Weekly Recap Button',
    PASSWORD_PROTECTION_BUTTON: 'Password Protection Button',
    SET_PASSWORD_BUTTON: 'Set Password Button',
    UNLOCK_NOW_BUTTON: 'Unlock Now Button',
    RATE_US_POPUP: 'Rate Us Popup',
    PASSWORD_PROTECTION_POPUP: 'Password Protection Popup',
    CANCEL_BUTTON: 'Cancel Button',
    UNLOCK_BUTTON: 'Unlock Button',
    ALREADY_PREMIUM_POPUP: 'You Are Already Premium Popup',
    RULES_PAGE: 'Rules Page',
    RULES_CALLOUT_POPUP: 'Rules Callout Popup',
    GOT_IT_BUTTON: 'Got It Button',
    CREATE_NEW_RULE_BUTTON: 'Create New Rule Button',
    ADD_NEW_RULE_BUTTON: 'Add New Rule Button',
    EDIT_RULE_BUTTON: 'Edit Rule Button',
    ADD_TO_BLOCK_LIST_POPUP_NEW: 'Add to Block List Popup New',
    ADD_TO_BLOCK_LIST_POPUP_ADD: 'Add to Block List Popup Add',
    ADD_TO_BLOCK_LIST_POPUP_EDIT: 'Add to Block List Popup Edit',
    UPGRADE_BUTTON: 'Upgrade Button',
    LOCKED_CATEGORY_BUTTON: 'Locked Category Button',
    LOCKED_KEYWORD_BUTTON: 'Locked Keyword Button',
    SAVE_BUTTON: 'Save Button',
    DONE_ADD_ITEMS_TO_BLOCK_LIST: 'Done Add Items to Block List',
    OAUTH_BANNER: 'oAuth Banner',
    DELETE_GROUP_BUTTON: 'Delete Group Button',
    DELETE_GROUP_POPUP: 'Delete Group Popup',
    TURN_OFF_GROUP_BUTTON: 'Turn Off Group Button',
    TURN_OFF_GROUP_POPUP: 'Turn Off Group Popup',
    TURN_ON_WHITELIST_BUTTON: 'Turn On Whitelist Button',
    TURN_OFF_WHITELIST_BUTTON: 'Turn Off Whitelist Button',
    TURN_ON_REDIRECT_BUTTON: 'Turn On Redirect Button',
    TURN_OFF_REDIRECT_BUTTON: 'Turn Off Redirect Button',
    BRAZE: {
      ONBOARDING_COMPLETE: 'onboarding complete',
      BLOCKED_SCREEN_VIEWED: 'Blocked_screen_viewed',
      DOWNLOAD_LINK_REQUESTED: 'download_link_requested',
      NEW_RULE_BUTTON_CLICK: 'New_rule_button_click',
      GROUP_CREATED: 'Group_created',
      CATEGORY_ADDED_GROUP: 'Category_added_group',
      WEBSITE_ADDED_GROUP: 'Website_added_group',
      WORD_ADDED_GROUP: 'Word_added_group',
      GROUP_DELETED: 'Group_deleted',
      SCHEDULE_STOPPED: 'Schedule_stopped',
      WHITELIST_MODE_ON: 'whitelist_mode_on',
      WHITELIST_MODE_OFF: 'whitelist_mode_off',
    },
  },
  BRAZE_ATTRIBUTES: {
    WHITELIST_ITEMS_AMOUNT: 'whitelist_items_amount',
    WHITELIST_ITEMS_NAMES: 'whitelist_items_names',
    WHITELIST_STATUS: 'whitelist_status',
  },
  SCREEN: {
    BLOCK_SITE_PAGE: 'Block Site Page',
    BLOCK_PAGE: 'Block Page',
    SETTINGS_PAGE: 'Settings Page',
    RULES_PAGE: 'Rules Page',
  },
  SOURCE: {
    ONBOARDING: 'Onboarding',
    PERMISSIONS_BANNER: 'Permissions Banner',
    // For entry points outside this app, when the URL declares no source.
    OTHER: 'Other',
    LEFT_NAVBAR: 'Left Navbar',
    ONBOARDING_CHECKOUT_MODAL: 'Onboarding Checkout Modal',
    ONBOARDING_PLAN_PICKER_POPUP: 'Onboarding Plan Picker Popup',
    ONBOARDING_ADD_TO_BLOCK_LIST_POPUP: 'Onboarding Add to Block List popup',
    ONBOARDING_AUTHENTICATION_MODAL: 'Onboarding Authentication Modal',
    ONBOARDING_OPT_IN_POPUP: 'Onboarding Opt In Popup',
    RECONSENT_BANNER: 'Reconsent Banner',
    SETTINGS_TOGGLE: 'Settings Toggle',
    RULE_FORM_CATEGORIES_TAB: 'Rule Form Categories Tab',
    BLOCK_PAGE_RATE_US: 'Block Page Rate Us',
    BLOCK_PAGE_RATE_US_POPUP: 'Block Page Rate Us Popup',
    BLOCK_PAGE_ADD_ITEM_BUTTON: 'Block Page Add Item Button',
    BLOCK_PAGE_SET_SCHEDULE_BUTTON: 'Block Page Set Schedule Button',
    BLOCK_PAGE_SET_DAILY_LIMIT_BUTTON: 'Block Page Set Daily Limit Button',
    BLOCK_PAGE_START_FOCUS_SESSION_BUTTON:
      'Block Page Start Focus Session Button',
    BLOCK_PAGE_SEE_WEEKLY_RECAP_BUTTON: 'Block Page See Weekly Recap Button',
    BLOCK_PAGE_SET_PASSWORD_BUTTON: 'Block Page Set Password Button',
    BLOCK_PAGE_PASSWORD_PROTECTION_POPUP:
      'Block Page Password Protection Popup',
    CHECKOUT: 'Checkout',
    ACCOUNT_DROPDOWN: 'Account Dropdown',
    WEB_APP: 'Web App',
    BLOCK_PAGE: 'Block Page',
    GROUPS_LIMIT_BANNER: 'groups_limit_banner',
    RULES_PAGE: 'Rules Page',
    RULES_CALLOUT_POPUP: 'Rules Callout Popup',
    CREATE_NEW_RULE_BUTTON: 'Create New Rule Button',
    ADD_NEW_RULE_BUTTON: 'Add New Rule Button',
    EDIT_RULE_BUTTON: 'Edit Rule Button',
    DELETE_GROUP_POPUP: 'Delete Group Popup',
    TURN_OFF_GROUP_POPUP: 'Turn Off Group Popup',
    // spec value for the locked keyword source in edit mode, kept as written
    ADD_TO_BLOCK_LIST_EDIT_ADD: 'Add to Block List Edit Add',
  },
  PROPERTIES: {
    SITE_VERSION: 'Site Version',
    SCREEN: 'Screen',
    REFERRER_URL_PATH: 'Referrer URL Path',
    EXPERIMENT_NAME: 'Experiment Name',
    VARIANT_NAME: 'Variant Name',
    VARIANT_VALUE: 'Variant Value',
    IS_SP_INFRA: 'Is SP Infra',
    PLATFORM: 'Platform',
    URL_PATH: 'URL Path',
    IS_EXTENSION: 'Is Extension',
    TIER: 'Tier',
    PERMISSIONS: 'Permissions',
    IS_TEST_USER: 'Is Test User',
    FIREBASE_ID: 'Firebase Id',
    UUID: 'UUID',
    HAS_PASSWORD_PROTECTION: 'Has Password Protection',
    HAS_PASSWORD_PREVENTION: 'Has Uninstall Prevention',
    PAGE_TYPE: 'Page Type',
    SUBSCRIPTION_STATUS: 'Subscription Status',
    SUBSCRIPTION_IS_ON_TRIAL: 'Subscription Is On Trial',
    SUBSCRIPTION_PLAN: 'Subscription Plan',
    SUBSCRIPTION_AGE: 'Subscription Age',
    INSTALL_AGE: 'Install Age',
    EVENT_TYPE: 'Event Type',
    ONBOARDING_STEP: 'Onboarding Step',
    SOURCE: 'Source',
    PLAN_NAMES: 'Plan Names',
    PLAN_IDS: 'Plan IDs',
    PLAN_NAME: 'Plan Name',
    DURATIONS: 'Durations',
    DURATION: 'Duration',
    PRICES: 'Prices',
    PRICE: 'Price',
    CURRENCY: 'Currency',
    IS_TRIAL: 'Is Trial',
    IS_IMMEDIATE_PAY: 'Is Immediate Pay',
    DISCOUNT_PERCENTAGE: 'Discount Percentage',
    EMAIL: 'Email',
    LOGIN_TYPE: 'Login Type',
    IS_PREMIUM_HOOK: 'Is Premium Hook',
    PLAN_ID: 'Plan ID',
    START_TRIAL: 'Start Trial',
    SUBSCRIPTION_ID: 'Subscription ID',
    PAYMENT_PROVIDER: 'Payment Provider',
    PIN_EXTENSION_TASK_COMPLETED: 'Pin Extension Task Completed',
    VISIT_BLOCK_PAGE_TASK_COMPLETED: 'Visit Blocked Page Task Completed',
    TASK: 'Task',
    ITEMS_ADDED: 'Items Added',
    NO_SITES_ADDED: 'No Sites Added',
    NO_CATEGORIES_ADDED: 'No Categories Added',
    NO_KEYWORDS_ADDED: 'No Keywords Added',
    SITES_ADDED: 'Sites Added',
    CATEGORIES_ADDED: 'Categories Added',
    KEYWORDS_ADDED: 'Keywords Added',
    FEATURES_ADDED: 'Features Added',
    BLOCK_MODE: 'Block Mode',
    BLOCK_TYPE: 'Block Type',
    ACTIVATION_SOURCE: 'Activation Source',
    IS_GRANTED: 'Is Granted',
    CONSENT_LIST: 'Consent List',
    CONSENT_VARIANT: 'Consent Variant',
    APP_VERSION: 'App Version',
    AUTHENTICATION_TYPE: 'Authentication Type',
    RATE_SUBMITTED: 'Rate Submitted',
    WEBSITE_NAME: 'Website_name',
    IS_VALID: 'Is Valid',
    STEP: 'Step',
    GA_USER_PSEUDO_ID: 'ga_user_pseudo_id',
    GA_SESSION_ID: 'ga_session_id',
    TYPE: 'Type',
    STATE: 'State',
    GROUP_NAME: 'Group Name',
    GROUPS_STATE: 'Groups State',
    PERMISSIONS_TYPE: 'Permissions Type',
  },
  /**
   * User profile properties for Mixpanel People
   */
  PROFILE_PROPERTIES: {
    IS_LOGGED_IN: 'Is Logged In',
    HAD_TRIAL: 'Had Trial',
    FIREBASE_ID: 'Firebase Id',
    UUID: 'UUID',
    EMAIL: '$email',
    TIER: 'Tier',
  },
  TYPES: {
    SHOWN: 'Shown',
    CLICK: 'Click',
    LOGIN: 'Log In',
    REGISTRATION: 'Registration',
    PAGE_VIEW: 'Page View',
    LINK_CLICK: 'Link Click',
    OPT_IN: 'Opt In',
    OPT_IN_BUCKETS: 'Opt In Buckets',
    OPT_IN_AI: 'Opt In AI',
  },
  CONSENT_ITEM: {
    ALL: 'All',
    CS: 'CS',
    BUCKETS: 'Buckets',
    AI: 'AI',
    EULA: 'EULA',
    TERMS_AND_CONDITIONS: 'T&C',
  },
  // Values pushed into the `Permissions` super property.
  PERMISSION: {
    OAUTH: 'oAuth',
    OPT_IN: 'Opt in',
    OPT_IN_BUCKETS: 'Opt in Buckets',
    TERMS_AND_CONDITIONS: 'T&C',
    AFFILIATE: 'Affiliate',
    THIRD_PARTY: 'Third Party',
  },
  VALUES: {
    STRIPE: 'Stripe',
    PAYPAL: 'PayPal',
    WEB: 'Web',
    SHOWN: 'Shown',
    VIEW: 'View',
    CLICK: 'Click',
    ANONYMOUS: 'Anonymous',
    FREE: 'Free',
    PREMIUM: 'Premium',
    YEARLY: 'Yearly',
    MONTHLY: 'Monthly',
    HEADER: 'Header',
    ONE_TAP_LOGIN: 'One Tap Logon',
    CHECKOUT: 'Checkout',
    PLANS: 'Plans',
    CHECKOUT_MODAL: 'Checkout Modal',
    PURCHASE_PAGE: 'Purchase Page',
    INSIGHTS_PAGE_CHANGE_TIME_RANGE:
      'options_insights_change_insights_time_range',
    ADD_ITEM_PREMIUM_CTA: 'add_item_premium_cta', // TODO:: complete
    HEADER_PREMIUM_CTA: 'Upgrade_Top_Button_BLOCK_SITES_Page',
    CUSTOMIZE_BLOCK_PAGE_HOOK: 'Get_Custom_Block_Button_Custom_Block_Page',
    BLOCK_PAGE_PASSWORD_PROTECTION_CTA: 'Block Page Password Protection Button',
    BLOCK_PAGE_SIGNUP: 'Block Page Signup',
    PROFILE_MENU_PREMIUM_ITEM: 'ProfileMenuPremiumItem',
    SETTINGS_SLACK: 'SettingsSlack',
    OMNI_SOURCE_FALLBACK: 'OmniSetupFallback',
    OMNI_SOURCE: 'OmniSetup',
    LIMIT_TIME_DISCOUNT_HEADER: 'Limited Time Discount Header',
    BLOCK_SITES: 'Block Sites',
    BLOCK_CATEGORIES: 'Block Categories',
    BLOCK_KEYWORDS: 'Block Keywords',
    BLACK_LIST: 'Black List',
    WHITE_LIST: 'White List',
    SCHEDULE: 'Schedule',
    FOCUS_MODE: 'Focus Mode',
    TIME_USAGE: 'Time Usage',
    LOGIN: 'Login',
    SIGNUP: 'Signup',
    NEW: 'New',
    ADD: 'Add',
    EDIT: 'Edit',
    FIRST_EVER: 'First Ever',
    EMPTY: 'Empty',
    FULL: 'Full',
    ON: 'ON',
    OFF: 'OFF',
  },
  GA_EVENTS: {
    UNINSTALL: 'uninstall',
  },
};

export const PREV_PAGE_STORAGE_KEY = 'prevUrlPath';
export const PAGE_VIEW_TYPE_STORAGE_KEY = 'pageViewType';
export const PAGE_VIEW_SOURCE = 'pageViewSource';
export const SOURCE = 'source';
export const PLAN_SOURCE = 'planSource';
export const UTM_SOURCE = 'utm_source';

export const MIXPANEL_CONFIG = {
  PROXY_PATH: '/mp-proxy',
  TRACK_ENDPOINT: 'https://api.mixpanel.com/track',
  EXPERIMENT_SEND_DELAY_MS: 50,
} as const;
